"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));
var Styled = _interopRequireWildcard(require("./styles/IconClapping.style"));
var _ruleSet = require("../../ruleSet");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var IconClapping = function IconClapping(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
    _ref$isResponsive = _ref.isResponsive,
    isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    state = _ref.state,
    numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m10.059 10.82-1.16-.957c-.438-.355-1.06-.328-1.383.067l-.04.047c-.32.398-.226 1.007.208 1.367l1.191.98m3.835 3.156-3.835-3.152c-.438-.36-1.059-.332-1.375.063l-.04.046c-.32.395-.23 1.012.208 1.368l1.582 1.308",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m11.492 16.96-2.25-1.847a.966.966 0 0 0-1.36.125l-.034.047c-.325.39-.235 1.012.203 1.367l2.215 1.817s3.57 3.023 5.656 3.07c1.512.035 2.465-.473 3.305-1.5.441-.539 1.59-1.637.918-4.125-1.211-4.5-1.696-6.539-1.696-6.539s-1.3-.04-1.347 1.508c-.024.875.449 2.363 0 2.527-.239.086-.684-.031-1.946-.91-.406-.281-3.875-3.176-3.875-3.176-.433-.36-1.054-.332-1.383.067l-.035.043c-.324.398-.238 1.015.203 1.375l3.852 3.164m-6.613 1.632-2.278-1.25c-.492-.273-.691-.863-.441-1.312l.031-.05v-.009c.266-.46.836-.683 1.297-.418l1.387.723-2.375-1.234c-.492-.274-.692-.864-.442-1.313l.032-.05c.25-.446.902-.594 1.394-.32",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.652 11.309 4.527 9.625c-.492-.273-.691-.863-.441-1.313l.031-.05c.25-.45.86-.586 1.352-.309l3.203 1.77-1.899-1.036c-.5-.273-.691-.867-.441-1.312l.027-.05c.25-.45.86-.59 1.352-.313 0 0 3.926 2.242 4.375 2.449 1.394.64 1.855.676 2.074.555.418-.243-.312-1.625-.441-2.493C13.5 6 14.78 5.805 14.78 5.805s1.41 2.812 2.328 4.933M8.469 4.906V2.777m3.019 3.141 1.602-1.602m-2.953.801L11.46 1.84",
    vectorEffect: "non-scaling-stroke"
  }))), numberBadge ? /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })) : null);
};
IconClapping.displayName = "IconClapping";
var _default = IconClapping;
exports["default"] = _default;